// polyfill
import "core-js/stable";
import "intersection-observer";
import "regenerator-runtime/runtime";

// service-worker.js activator
import "./registerServiceWorker";

// core
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";

import VueWait from "vue-wait";

import vuexI18n from "vuex-i18n";
import Locales from "./../backend/resources/js/vue-i18n-locales.generated";

// bootstrap
import {
  AlertPlugin,
  AvatarPlugin,
  BadgePlugin,
  ButtonGroupPlugin,
  ButtonPlugin,
  ButtonToolbarPlugin,
  CardPlugin,
  CollapsePlugin,
  FormCheckboxPlugin,
  FormDatepickerPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTagsPlugin,
  FormTextareaPlugin,
  ImagePlugin,
  InputGroupPlugin,
  JumbotronPlugin,
  LayoutPlugin,
  LinkPlugin,
  ListGroupPlugin,
  ModalPlugin,
  NavbarPlugin,
  OverlayPlugin,
  PaginationNavPlugin,
  PopoverPlugin,
  ProgressPlugin,
  SidebarPlugin,
  SpinnerPlugin,
  TablePlugin,
  TabsPlugin,
  ToastPlugin,
  TooltipPlugin,
} from "bootstrap-vue";
Vue.use(FormRadioPlugin);
Vue.use(ToastPlugin);
Vue.use(TabsPlugin);
Vue.use(ProgressPlugin);
Vue.use(ModalPlugin);
Vue.use(ListGroupPlugin);
Vue.use(LinkPlugin);
Vue.use(JumbotronPlugin);
Vue.use(InputGroupPlugin);
Vue.use(ImagePlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormFilePlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(CollapsePlugin);
Vue.use(CardPlugin);
Vue.use(PaginationNavPlugin);
Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);
Vue.use(TablePlugin);
Vue.use(FormPlugin);
Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
Vue.use(FormTagsPlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(OverlayPlugin);
Vue.use(ButtonToolbarPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(AvatarPlugin);
Vue.use(TooltipPlugin);
Vue.use(SidebarPlugin);
Vue.use(PopoverPlugin);

// cookies
import VueCookies from "vue-cookies";

// form validation plugin
import VeeValidate from "vee-validate";

import { VueStars } from "vue-stars";
Vue.component("vue-stars", VueStars);

// awesome
import { library } from "@fortawesome/fontawesome-svg-core";
// regular
import {
  faClock,
  faFileAlt,
  faFilePdf,
  faHourglass,
  faStar as farStar,
} from "@fortawesome/free-regular-svg-icons";
// standard
import {
  faAlignJustify,
  faAngleDoubleDown,
  faAngleDoubleRight,
  faBell,
  faBold,
  faChartPie,
  faCheck,
  faCircleNotch,
  faCogs,
  faComment,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faForward,
  faHeading,
  faHouseUser,
  faInfoCircle,
  faItalic,
  faLink,
  faList,
  faLock,
  faLockOpen,
  faLongArrowAltRight,
  faMinus,
  faMinusCircle,
  faPaperclip,
  faParagraph,
  faPencilAlt,
  faPlus,
  faPlusCircle,
  faPollH,
  faQuoteRight,
  faReceipt,
  faRedo,
  faSave,
  faSignature,
  faSignInAlt,
  faSlash,
  faStar as fasStar,
  faStrikethrough,
  faTasks,
  faThumbsUp,
  faTicketAlt,
  faTimes,
  faTools,
  faTrashAlt,
  faUnderline,
  faUndo,
  faUserSecret,
  faWindowMinimize,
} from "@fortawesome/free-solid-svg-icons";

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";

library.add(
  faHouseUser,
  faCogs,
  faReceipt,
  faBell,
  faSignInAlt,
  faTasks,
  faHeading,
  faWindowMinimize,
  faRedo,
  faUnderline,
  faQuoteRight,
  faParagraph,
  faStrikethrough,
  faItalic,
  faBold,
  faLongArrowAltRight,
  faExternalLinkAlt,
  faPaperclip,
  faMinusCircle,
  faPlusCircle,
  faTimes,
  faEnvelope,
  faEllipsisV,
  faInfoCircle,
  faPollH,
  faList,
  faForward,
  faTools,
  faSignature,
  faAngleDoubleRight,
  faAngleDoubleDown,
  faExclamationTriangle,
  faChartPie,
  faThumbsUp,
  faComment,
  faSlash,
  fasStar,
  farStar,
  faLink,
  faDownload,
  faHourglass,
  faClock,
  faCheck,
  faUserSecret,
  faLockOpen,
  faLock,
  faCircleNotch,
  faAlignJustify,
  faPlus,
  faSave,
  faUndo,
  faTrashAlt,
  faMinus,
  faExclamation,
  faEye,
  faEyeSlash,
  faPencilAlt,
  faFileAlt,
  faTicketAlt,
  faFilePdf
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);
Vue.component("font-awesome-layers", FontAwesomeLayers);

// mix's
import localDate from "@/mixins/localDate.js";
import toast from "@/mixins/toast.js";
import validateState from "@/mixins/validateState.js";

Vue.mixin(toast);
Vue.mixin(validateState);
Vue.mixin(localDate);

// import fadeTransition from "@/components/utils/FadeTransition";
// Vue.component('fadeTransition', fadeTransition)

Vue.use(VueCookies);

// multi-language
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add("en", Locales.en);
Vue.i18n.add("de", Locales.de);
Vue.i18n.add("fr", Locales.fr);
Vue.i18n.set("en");

Vue.use(VueWait);
Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: "veeFields",
  // This is not required but avoids possible naming conflicts
  errorBagName: "veeErrors",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  wait: new VueWait({
    useVuex: true,
  }),
  render: (h) => h(App),
}).$mount("#app");
